export default __webpack_public_path__ + "static/devassa-23f914d705d40cd92a22521868da87ee.jpg";